import { render, staticRenderFns } from "./SithMesInventoryLiftRiggingsEdit.vue?vue&type=template&id=65d9fa96&"
import script from "./SithMesInventoryLiftRiggingsEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryLiftRiggingsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports